enum UserType {
  NOT_DEFINED = '',
  NORMAL = 'N',
  OWNER = '0',
}

export default UserType;
